import React from "react";
import { Helmet } from "react-helmet-async";
import "./styles.css";

const PAYPAL_LINK = "https://www.paypal.me/Kevin222316";
const CASH_APP_LINK = "https://cash.app/$KevinRispoli";
const BMC_QR_IMAGE = `${process.env.PUBLIC_URL}/bmc_qr.png`;

function DonatePage() {
  return (
    <>
      <Helmet>
        <title>Donate | Knowall Paranormal</title>
        <meta
          name="description"
          content="Support Knowall Paranormal through PayPal, Cash App, or Buy Me a Coffee."
        />
      </Helmet>

      <div className="page-container">
        <section className="section donate-section">
          <h1 className="section-title">Support Knowall Paranormal</h1>
          <p className="section-description">
            If you want to support our investigations and content, you can
            donate below using PayPal, Cash App, or Buy Me a Coffee.
          </p>

          <div className="donate-grid">
            <div className="donate-panel">
              <h2>PayPal & Cash App</h2>
              <p>Quick support options through your preferred app.</p>

              <div className="donate-buttons">
                <a
                  href={PAYPAL_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-paypal donate-button"
                >
                  Donate with PayPal
                </a>
                <a
                  href={CASH_APP_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-cashapp donate-button"
                >
                  Donate with Cash App
                </a>
              </div>
            </div>

            <div className="donate-panel">
              <h2>Buy Me a Coffee</h2>
              <p>Scan this QR code in your camera app to support us.</p>

              <div className="donate-qr-box">
                <img
                  src={BMC_QR_IMAGE}
                  alt="Buy Me a Coffee QR code"
                  className="cashapp-image"
                />
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default DonatePage;
